/**
 * signupDraft.ts
 * In-memory draft store for the multi-step signup form. The signup screen
 * unmounts whenever the user navigates away (e.g. taps "Sign in"), which would
 * normally wipe the typed fields. Persisting the draft here keeps the user's
 * data intact across navigation; it is cleared only once the account is created
 * (successful signup) or on explicit reset.
 *
 * Backed by the shared `createDraftStore` factory (see utils/draftStore.ts):
 * module-level (not AsyncStorage) — the draft lives for the session/tab only,
 * passwords are never written to disk, and it is dropped the moment it's no
 * longer needed.
 */

import { createDraftStore } from '../../utils/draftStore';

export interface SignupDraft {
  form: any;
  step: 1 | 2 | 3;
}

const store = createDraftStore<SignupDraft>();

export const getSignupDraft = store.get;
export const setSignupDraft = store.set;
export const clearSignupDraft = store.clear;
